// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"ModelListItem_itemContainer__1x0p1","itemFooter":"ModelListItem_itemFooter__1hjj3","timeInfo":"ModelListItem_timeInfo__3WSgr"};